import * as Yup from 'yup';

export const signInPersonalIdValidationSchema = Yup.object().shape({
    personalId: Yup.string().required('Osobní číslo je povinné')
});

export const signInPinCodeValidationSchema = Yup.object().shape({
    pinCode: Yup.string().required('Pin kód je povinný')
});
